module.exports = __webpack_public_path__ + "static/media/45.801600a0.jpg";